export default __webpack_public_path__ + "static/media/Pistol_4.4735fd9b.png";